// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__fevmZ","header":"LoginForm_header__-JybS","icon":"LoginForm_icon__oGdsX","title":"LoginForm_title__lmvLK","subtitle":"LoginForm_subtitle__G7quJ"};